var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.125 0a6.125 6.125 0 1 0 0 12.25 6.125 6.125 0 0 0 0-12.25Zm0 11.21a5.087 5.087 0 1 1 .002-10.173 5.087 5.087 0 0 1-.002 10.174Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.513 7.856-1.95-1.41V3.063a.11.11 0 0 0-.109-.11h-.657a.11.11 0 0 0-.11.11v3.765c0 .035.017.068.046.089l2.26 1.648a.11.11 0 0 0 .154-.023l.391-.533a.11.11 0 0 0-.025-.153Z"
  })));
};
export default SvgClock;